import { useState } from "react";
// import {
//   AiFillTwitterCircle,
//   AiFillLinkedin,
//   AiFillYoutube,
// } from "react-icons/ai";
// import { BsFillMoonStarsFill } from "react-icons/bs";
import "./App.css";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Testimonials from "./components/Testimonials";
import amaz from "./img/amaz.png";

function App() {
  const [darkMode, setDarkMode] = useState(false);
  return (
    <div className="text-gray-400 bg-gray-900 body-font">
      <Navbar />
      <About amaz={amaz} />
      <Projects />
      <Skills />
      <Testimonials />
      <Contact />
    </div>
  );
}

export default App;
